import DeviceOverviewContainer from '~/modules/devices/containers/DeviceOverviewContainer';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

export default dashboardWrapper(DeviceOverviewContainer, t('menu.dashboard.deviceOverview'));
